module.exports = __webpack_public_path__ + "static/media/bg.ae0f8e39.png";